'use client';

import { FC } from 'react';
import BasicCircleDemo from './BasicShapesDemo/BasicCircleDemo';
import BasicEllipseDemo from './BasicShapesDemo/BasicEllipseDemo';
import BasicRectangleDemo from './BasicShapesDemo/BasicRectangleDemo';
import BasicPolygonDemo from './BasicShapesDemo/BasicPolygonDemo';
import BasicPolylineDemo from './BasicShapesDemo/BasicPolylineDemo';
import BasicTextDemo from './BasicShapesDemo/BasicTextDemo';
import BasicLineDemo from './BasicShapesDemo/BasicLineDemo';
import CenteredStrokeDemo from './BasicShapesDemo/CenteredStrokeDemo';
import PolygonFamilyDemo from './BasicShapesDemo/PolygonFamilyDemo';
import RoundedRectangleBasicDemo from './BasicShapesDemo/RoundedRectangleBasicDemo';
import RoundedRectangleAdvancedDemo from './BasicShapesDemo/RoundedRectangleAdvancedDemo';
import StrokeStylesDemo from './StrokeStylesDemo/StrokeStylesDemo';
import StrokeDashOffsetDemo from './StrokeDashOffsetDemo';
import SelfDrawingDemo from './SelfDrawingDemo';
import CasinoLightsEffect from './DashOffsetEffects/CasinoLightsEffect';
import FancyLoadingSpinner from './DashOffsetEffects/FancyLoadingSpinner';

type DemoComponent = FC<Record<string, unknown>>;

const MAP: Record<string, DemoComponent> = {
  BasicCircleDemo,
  BasicEllipseDemo,
  BasicRectangleDemo,
  BasicPolygonDemo,
  BasicPolylineDemo,
  BasicTextDemo,
  BasicLineDemo,
  CenteredStrokeDemo,
  PolygonFamilyDemo,
  RoundedRectangleBasicDemo,
  RoundedRectangleAdvancedDemo,
  StrokeStylesDemo,
  StrokeDashOffsetDemo,
  SelfDrawingDemo,
  CasinoLightsEffect,
  FancyLoadingSpinner,
};

interface SVGDemoProps {
  componentName: keyof typeof MAP;
  [key: string]: unknown;
}

export default function SVGDemo({
  componentName,
  ...props
}: SVGDemoProps) {
  const Component = MAP[componentName];
  return <Component {...props} />;
}
